import { render, staticRenderFns } from "./EstimatesOldPageTaskItem.vue?vue&type=template&id=6afbfd28&"
import script from "./EstimatesOldPageTaskItem.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldPageTaskItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports